'use client';

/**
 * SysObeyaKpiHighCcCountCard — Complexity Hotspots KPI tile.
 *
 * Slices `response.totals.{total_high_cc_functions, total_functions}`
 * from the system_obeya_view high_cc_functions call. Hero number is
 * the count of high-CC functions; sub-label shows "of {total}".
 *
 * @see klyde_edge/ui_config/composition/cards/system_obeya.py — content_key="sys_obeya_kpi_high_cc_count"
 * @see klyde_edge/ui_config/labels/system_obeya.py — high_cc_kpi_high_cc_functions_*
 */

import { Cpu } from 'lucide-react';
import { useSystemObeyaView } from './use-system-obeya-view';
import { KpiTile, fmt } from './kpi-tile';

interface Props {
  view_name?: string;
}

export function SysObeyaKpiHighCcCountCard({ view_name = 'high_cc_functions' }: Props) {
  const { data, isLoading, queryKey } = useSystemObeyaView(view_name);
  const L = data?.labels ?? {};
  const t = data?.totals ?? {};
  return (
    <KpiTile
      contentKey="sys_obeya_kpi_high_cc_count"
      label={L.high_cc_kpi_high_cc_functions_label ?? ''}
      Icon={Cpu}
      value={isLoading ? '…' : fmt(t.total_high_cc_functions)}
      sub={`${L.high_cc_kpi_high_cc_functions_sub_prefix ?? ''}${fmt(t.total_functions)}`}
      queryKey={queryKey}
    />
  );
}
